// import { Buffer } from "buffer";

export const isMobileDevice = (): boolean => {
    return window.innerWidth <= 800;
};

export const convertStringToBase64 = (data: string): string => {
    // var Buffer = require('buffer').Buffer;
    let result = Buffer.from(data, 'utf-8').toString('base64');
    return result;
}

// export const convertBase64ToBlob = (data: string): Blob => {
//     // var Buffer = require('buffer').Buffer;
//     let result = Buffer.from(data, 'base64');
//     return result;
// }

export const timeToString = (time: number): string => {
    if (time === 0) return '00:00';

    return Math.floor(time / 100).toString().padStart(2, '0') + ":" +
        (time - Math.floor(time / 100) * 100).toString().padStart(2, '0');
}

export const dateWStoDateStr = (date?: string): string =>
    date ? date.substring(8, 10) + '/' + date.substring(5, 7) + '/' + date.substring(0, 4) : ''

// Data locale in formato WS (YYYY-MM-DD), senza passare da UTC come toJSON()
export const dateToStringWS = (date: Date): string =>
    date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0')

export const multiSelectLabel = {
    "allItemsAreSelected": "Tutti selezionati",
    "clearSearch": "Cancella ricerca",
    "clearSelected": "Clear Selected",
    "noOptions": "Nessuna opzione",
    "search": "Ricerca",
    "selectAll": "Seleziona Tutto",
    "selectAllFiltered": "Seleziona tutto (Filtrato)",
    "selectSomeItems": "Seleziona",
    "create": "Crea",
}

export const formatTime = (time: number): string => {
    const hours = Math.floor(time / 100).toString().padStart(2, '0');
    const minutes = (time % 100).toString().padStart(2, '0');
    return `${hours}:${minutes}`;
};

export const parseTime = (time: string): number => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 100 + minutes;
};
